import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, FormLabel, Input, Stack, TextareaAutosize } from '@mui/material';
import useBundleTranslation from 'i18n';
import { IItemFlowProps } from '../item-wrapper/index';

import JsonField from './components/JsonField';

interface DataSet {
    message: string;
    stateMap: string;
    inputJson: string;
}
export default function ChatMessage({ workflowItemSettings, saveItemSettings }: IItemFlowProps) {
    const { t } = useBundleTranslation(['app/admin/editor/generic-workflow/common']);

    const initialData: DataSet = {
        message: '',
        stateMap: '',
        inputJson: '',
    };

    try {
        const tmp: any = JSON.parse(workflowItemSettings);
        if (tmp?.message) initialData.message = tmp.message;
        if (tmp?.stateMap) initialData.stateMap = tmp.stateMap;
        if (tmp?.inputJson) initialData.inputJson = tmp.inputJson;
    } catch (e) {}

    const [message, setMessage] = useState(initialData.message);
    const [stateMap, setStateMap] = useState(initialData.stateMap);
    const [inputJson, setInputJson] = useState(initialData.inputJson);

    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        saveItemSettings({
            message,
            stateMap,
            inputJson,
        });
    }, [message, stateMap]);

    return (
        <Stack>
            <Box>
                <FormLabel>{t('message')}</FormLabel>
                <Box>
                    <TextareaAutosize
                        style={{ width: '100%' }}
                        minRows={5}
                        maxRows={20}
                        onChange={(event) => {
                            setMessage(event.target.value);
                        }}
                        value={message}
                    />
                </Box>
            </Box>
            <Box>
                <FormLabel>{t('input')}</FormLabel>
                <JsonField
                    value={inputJson}
                    onChange={(value) => {
                        setInputJson(value);
                    }}
                />
            </Box>

            <Box>
                <FormLabel>{t('state_map')}</FormLabel>
                <JsonField
                    value={stateMap}
                    onChange={(value) => {
                        setStateMap(value);
                    }}
                />
            </Box>
        </Stack>
    );
}
